module.exports = __webpack_public_path__ + "img/gallery_pic7-compressed.c8c55bde.jpg";